
  import { css } from 'lit';
  export const styles = css`:host{--item-background-hover: var(--ig-list-item-background-hover, var(--ig-gray-100));--item-background-active: var(--ig-list-item-background-active, var(--ig-gray-100));--item-background-selected: var(--ig-list-item-background-selected, var(--ig-gray-100));--ig-theme-variant: dark}`;
  